import { useMutation } from "@tanstack/react-query";
import { RecalculateKPIs } from "PFCore/services/kpi";
import { Id, MutationOptions } from "PFCore/types";
import { KPIResult } from "PFCore/types/kpi";

import { KPIMutationKeys } from "./kpi_mutation_keys";
import { KPIKeys } from "./query_keys";

export const useKPIRecalculations = (engagementId: Id, options: MutationOptions<void, KPIResult[]> = {}) =>
  useMutation<KPIResult[], unknown, void>({
    mutationKey: KPIMutationKeys.recalculations(engagementId),
    mutationFn: () => RecalculateKPIs(engagementId),
    meta: {
      invalidation: {
        replace: true,
        queryKeys: [KPIKeys.kpiResults(engagementId)]
      }
    },
    ...options
  });
